import React from "react";
import Navbar from "./Navbar";
import WrapperContainer from "./utilities/WrapperContainer";

export function ContactText() {
  return (
    <>
      <p className="sub-step-bold">New Customers</p>
      <p>
        Interested customers may reach out by using the contact form found at{" "}
        <a
          href="https://cibermed.com/contact/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "black", fontWeigth: "200" }}
        >
          https://cibermed.com/contact/
        </a>
      </p>
      <br />
      <p className="sub-step-bold">Existing Customers</p>
      <p>
        For technical support with iSort&trade; products, or questions about
        tokens, existing customers may reach out to{" "}
        <a
          href="mailto:support@cibermed.com"
          style={{ color: "black", fontWeigth: "200" }}
        >
          support@cibermed.com
        </a>
        . Our support team will respond in a timely manner.{" "}
      </p>
      <p>
        For all other inquiries, please email{" "}
        <a href="mailto:support@cibermed.com" style={{ color: "black" }}>
          info@cibermed.com
        </a>
        .
      </p>
    </>
  );
}
export default function Contact() {
  return (
    <>
      <Navbar />
      <WrapperContainer
        maxwidth="60%"
        title="Contact"
        content={<ContactText />}
        loggedin={true}
      />
    </>
  );
}
